module.exports = __webpack_public_path__ + "img/logo.d75ea1cd.png";